import { render, staticRenderFns } from "./FormInstructionalMethods.vue?vue&type=template&id=bb0b9716&"
import script from "./FormInstructionalMethods.vue?vue&type=script&lang=js&"
export * from "./FormInstructionalMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports